$(document).ready(function() {
    var openText = $(".ttgMainMenu").data("open");
    var closeText = $(".ttgMainMenu").data("close");
    // Mobile Navigation
    if ($('#nav-menu-container').length) {
        var $mobile_nav = $('#nav-menu-container').clone().prop({
            id: 'mobile-nav',
            style: 'display: none',
            tabindex: '-1'
        });
        $mobile_nav.find('> ul').attr({
            'class': ''
        });
        $('.ttgLogoMenuContainer').after('<div id="mobile-nav-wrap"><button type="button" id="mobile-nav-toggle" aria-expanded="false"><span class="sr-only">' + openText + '</span><span class="fas fa-bars"></span></button><div id="mobile-nav-menu-container" aria-modal="true" role="dialog" style="display: none;"><button type="button" id="mobile-nav-close"><span class="sr-only">' + closeText + '</span><span class="fas fa-times"></span></button></div></div>');
        $('#mobile-nav-menu-container').append($mobile_nav);
        $('body').append('<div id="mobile-body-overly"></div>');


        $(document).on('click', '.menu-has-children span', function(e) {
            $(this).next().toggleClass('menu-item-active');
            $(this).nextAll('ul').eq(0).slideToggle();
            $(this).toggleClass("fa-angle-up fa-angle-down");
        });

        $(document).on('click', '#mobile-nav-toggle', function(e) {
            $('body').toggleClass('mobile-nav-active').toggleClass('has-dialog');
            $('#mobile-nav-toggle span').toggleClass('fa-times fa-bars');
            $('#mobile-nav').toggle();
            $('#mobile-nav-menu-container').toggle();
            $('#mobile-body-overly').toggle();
            $('#mobile-nav-toggle').attr('aria-expanded', function(i, attr) {
                return attr == 'true' ? 'false' : 'true';
            });
            $('#mobile-nav-toggle .sr-only').toggleText(openText, closeText);

            if ($('body').hasClass('mobile-nav-active')) {
                $("#skiplinks ul li a").attr("tabindex", "-1");
                openDialog("mobile-nav-menu-container", $("#mobile-nav-toggle"));
            } else {
                $("#skiplinks ul li a").removeAttr("tabindex");
            }
        });

        $(document).on('click', '#mobile-nav-close', function(e) {
            $("#mobile-nav-toggle").click();
            closeDialog("mobile-nav-close");
            $("#mobile-nav-toggle").focus();
        });


        $(document).click(function(e) {
            var container = $("#mobile-nav, #mobile-nav-toggle, #mobile-nav-close");
            if (!container.is(e.target) && container.has(e.target).length === 0) {
                if ($('body').hasClass('mobile-nav-active')) {
                    $("#mobile-nav-toggle").click();
                }
            }
        });

        //close with ESC
        $('#mobile-nav-wrap').on('keydown', function(e) {
            var KEYCODE_ESC = 27;
            if (e.keyCode === KEYCODE_ESC && $('body').hasClass('mobile-nav-active')) {
                $("#mobile-nav-toggle").click();
                $("#mobile-nav-toggle").focus();
            }
        });
    } else if ($("#mobile-nav, #mobile-nav-toggle").length) {
        $("#mobile-nav, #mobile-nav-toggle").hide();
    }

    var submenuOpenText = $(".ttgMainMenu").data("submenu-open");
    var submenuCloseText = $(".ttgMainMenu").data("submenu-close");

    //Mouseover Navigation schließen mit ESC
    $("#nav-menu-container .menu-has-children").on("mouseover", function() {
        $(this).addClass('menu-open');

    });
    $("#nav-menu-container .menu-has-children").on("mouseleave", function() {
        $(this).removeClass('menu-open');
    });

    $('body').on('keydown', function(e) {
        var KEYCODE_ESC = 27;
        if (e.keyCode === KEYCODE_ESC && $('#nav-menu-container').find('.menu-open')) {
            var temp = $('#nav-menu-container').find('.menu-open');
            temp.find('.menu-toggle').focus();
            temp.removeClass('menu-open');
        }
    });


    // $('li.menu-has-children .menu-toggle span.sr-only').text(submenuOpenText);
    $('li.menu-has-children').each(function(i) {
        $(this).find('.menu-toggle span.sr-only').text($(this).find('> a').text() + " - " + submenuOpenText);
    });

    $(".menu-toggle").click(function() {
        event.preventDefault();
        $(this).parent().toggleClass('menu-open');
        $('.menu-toggle').attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
        $(this).find('span.sr-only').toggleText(submenuOpenText, submenuCloseText);
    });

    // $('body .footer-menu-toggle span.sr-only').text(submenuOpenText);
    $('.nav-footer li.menu-has-children').each(function(i) {
        $(this).find('.footer-menu-toggle span.sr-only').text($(this).find('> strong a').text() + " - " + submenuOpenText);
    });

    $(".footer-menu-toggle").click(function() {
        event.preventDefault();
        $(this).parent().toggleClass('menu-open');
        $('.footer-menu-toggle').attr('aria-expanded', function(i, attr) {
            return attr == 'true' ? 'false' : 'true';
        });
        $(this).find('span.sr-only').toggleText(submenuOpenText, submenuCloseText);
    });

});

(function($) {
    $.fn.toggleText = function(a, b) {
        return this.text(this.text() == b ? a : b);
    };
}(jQuery));

function trapFocus(element) {
    var firstFocusableEl = $('#mobile-nav-toggle');
    var lastFocusableEl = $('#mobile-nav ul li:last-child a').last();
    var KEYCODE_TAB = 9;

    element.on('keydown', function(e) {
        var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) /* shift + tab */ {
            if ($(document.activeElement)[0].outerHTML == firstFocusableEl[0].outerHTML) {
                lastFocusableEl.focus();
                e.preventDefault();
            }
        } else /* tab */ {
            if ($(document.activeElement)[0].outerHTML == lastFocusableEl[0].outerHTML) {
                firstFocusableEl.focus();
                e.preventDefault();
            }
        }
    });
}